import { render, staticRenderFns } from "./CreatorEdit.vue?vue&type=template&id=cff03c64&scoped=true"
import script from "./CreatorEdit.vue?vue&type=script&lang=js"
export * from "./CreatorEdit.vue?vue&type=script&lang=js"
import style0 from "./CreatorEdit.vue?vue&type=style&index=0&id=cff03c64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cff03c64",
  null
  
)

export default component.exports